export interface AuditLogEntry {
  id: string;
  company_id: string;
  project_id?: string;
  module_code: string;
  entity_type: string;
  entity_id: string;
  action_code: string;
  summary: string;
  
  before_data?: any;
  after_data?: any;
  
  actor_user_id: string;
  request_id?: string;
  session_id?: string;
  ip_address?: string;
  user_agent?: string;
  device_type?: string;
  
  created_at: string;

  // Relations
  actor?: { id: string; full_name: string; avatar_url?: string };
  project?: { id: string; name: string };
}

export interface AuditFilters {
  projectId?: string;
  moduleCode?: string;
  entityType?: string;
  entityId?: string;
  actionCode?: string;
  actorId?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}

export interface AuditStats {
  total: number;
  uniqueUsers: number;
  successCount: number;
  failedCount: number;
  uniqueEntities: number;
}

export const AuditEntityMapping = {
  project: 'Dự án',
  construction_contract: 'Hợp đồng thi công',
  construction_boq_item: 'Hạng mục BOQ',
  construction_work_order: 'Lệnh thi công',
  construction_progress_log: 'Nhật ký thi công',
  construction_qa_inspection: 'Kiểm tra QA',
  construction_issue: 'Sự cố/NCR',
  material_request: 'Yêu cầu vật tư',
  equipment_assignment: 'Cấp phát thiết bị',
  construction_cost: 'Chi phí thi công',
  construction_payment: 'Thanh toán',
  approval: 'Phê duyệt',
} as const;
